<template>
<div class="position-relative mt-3" id="AffinityTable">

  <div class="actions text-right" id="AffinityTable-showAddEditDialog">
    <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="AffinityTable-add-Button">
      <span class="btn-icon" id="AffinityTable-addButton-span"><i class="fa fa-plus" aria-hidden="true" id="AffinityTable-addButton-data"></i></span>
      {{ 'ADD' | translate }}
    </button>
  </div>

  <vodal :show="showAddEditDialog"
         :width="400"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
         animation="rotate"
         @hide="closeDialog">
    <affinity-add-edit-dialog :edited="editedRow"
                              :covers="covers"
                              :insurers="insurers"
                              @save="onSaveNew"
                              @update="onUpdate"
                              @close="closeDialog"
                              id="AffinityTable-addEditDialog"
    ></affinity-add-edit-dialog>
  </vodal>
  <table class="table table-striped table-hover" id="AffinityTable-tableData">
    <caption></caption>
    <tr>
      <th>Collectiviteitscode</th>
      <th>Collectiviteitnaam</th>
      <th>Dekking</th>
      <th>Maatschappij</th>
      <th>Collectiviteitskorting (%)</th>
      <th>Startdatum</th>
      <th></th>
    </tr>
    <template v-for="row in rows">
      <tr>
        <td>{{ row.code }}</td>
        <td>{{ row.name }}</td>
        <td>{{ row.coverTypeTranslated }}</td>
        <td>{{ row.insurerNameTranslated }}</td>
        <td>{{ row.percentage }}</td>
        <td>{{ row.startDate }}</td>
        <td id="AffinityTable-tableButtons">
          <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" :id="'AffinityTable-tableEditButton-'+row.name">
            <span class="btn-icon" :id="'AffinityTable-tableEditSpan-'+row.name"><i class="fa fa-pencil" aria-hidden="true" :id="'AffinityTable-tableEditData-'+row.name"></i></span>
          </button>
          <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)" :id="'AffinityTable-tableDeleteButton-'+row.name">
            <span class="btn-icon" :id="'AffinityTable-tableDeleteSpan-'+row.name"><i class="fa fa-trash-o" aria-hidden="true" :id="'AffinityTable-tableDeleteData-'+row.name"></i></span>
          </button>
        </td>
      </tr>
    </template>
  </table>
  <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
          @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
          </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import AffinityAddEditDialog from './AffinityAddEditDialog';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { AffinityAddEditDialog, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      newRows: [],
      editedRow: null,
      covers: [],
      insurers: [],
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      selectedRow: null
    }
  },
  beforeMount() {
    this.loadRows();
    this.loadCovers();
    this.loadInsurers();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const affinityResponse = await this.rest.getAllAffinityRows();
      this.rows = affinityResponse.data.map(row => {
        row.coverTypeTranslated = row.coverType ? this.$options.filters.translate(row.coverType, 'cover') : '';
        row.insurerNameTranslated = row.insurerName ? this.$options.filters.translate(row.insurerName, 'insurer') : '';
        return row;
      });
    },
    async loadCovers() {
      const coverTypesResponse = await this.rest.getAllCoverTypes();
      this.covers = coverTypesResponse.data.map(coverCategory => coverCategory.coverType);
    },
    async loadInsurers() {
      const insurerNamesResponse = await this.rest.getAllInsurerNames();
      this.insurers = insurerNamesResponse.data;
    },
    async onSaveNew(row) {
      await this.rest.createAffinityRow(row);
      this.closeDialog();
      this.loadRows();
    },
    async onUpdate(row) {
      await this.rest.updateAffinityRow(row);
      this.closeDialog();
      this.loadRows();
    },
    onEdit(row) {
      const { coverTypeTranslated, insurerNameTranslated, ...rest } = row;
      this.editedRow = rest;
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.id !== rowId);
      this.rest.deleteAffinityRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = null;
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .vue-table {
    border: 0;

    th, td {
      border-right: 0;
      border-bottom: 0;
      border-left: 0;
    }

    thead > tr > th {
      padding-right: .75rem;
      padding-left: 30px !important;
    }

    .arrow:before {
      bottom: 12px;
      right: auto;
      left: 12px;
      font-family: 'FontAwesome', sans-serif;
    }

    .icon-button {
      opacity: 0;
      transition: opacity .1s ease-out;
    }

    tr:hover .icon-button {
      opacity: 1;
    }
  }

  .actions {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 0;

    .icon-button {
      padding-right: 15px;
      padding-left: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/affinity/AffinityTable.vue